import type { ComponentType } from "react";
import type { ModuleDefinition, SlotProps } from "../../core/platform/registry/registry";
import { onSaleFinalized, onSaleVoided, onSaleRefunded } from "./subscriber";
import { loadReplica, forgetReplicaCache } from "./replica";
import { InventoryButton } from "./ui/InventoryButton";

// Module-owned styles, imported here rather than from main.tsx so core never
// carries a stylesheet for a feature it does not know exists.
import "./ui/inventory.css";

/**
 * The inventory module, assembled (specs/004-inventory-recipes).
 *
 * The composition root and nothing else: resolution lives in
 * `resolve-recipe.ts`, the arithmetic in `deduction.ts`, the Dexie writes in
 * `subscriber.ts`, the recipe copy in `replica.ts`.
 *
 * REACHES CORE ONLY THROUGH EVENTS AND ONE SLOT. It subscribes to the sale
 * events core already emits and puts one button in `terminal.actions`; core
 * never calls it and learns nothing about ingredients (Principle III).
 */
export function createInventoryModule(): ModuleDefinition {
  return {
    id: "inventory",
    name: "Inventory",
    version: "0.1.0",

    subscribers: {
      "sale.finalized": onSaleFinalized,
      "sale.voided": onSaleVoided,
      "sale.refunded": onSaleRefunded,
    },

    slots: {
      // Cast for the same reason as peripherals': the slot contract is
      // deliberately untyped per slot so core never imports module types.
      "terminal.actions": InventoryButton as ComponentType<SlotProps>,
    },

    async onEnable() {
      await loadReplica();
    },

    onDisable() {
      forgetReplicaCache();
    },
  };
}

export default createInventoryModule;
